export const formatFileSize = (size: number): string => {
  return size >= 1e9
    ? (size / 1e9).toFixed(1) + ' ГБ'
    : size < 1e9 && size >= 1e6
      ? (size / 1e6).toFixed(1) + ' МБ'
      : (size / 1000).toFixed() + ' КБ'
}

export const filesToFileList = (files: File[]) => {
  const dt = new DataTransfer()
  for (const file of files) {
    dt.items.add(file)
  }
  return dt.files
}
